// extracted by mini-css-extract-plugin
export default {"container":"Xz-z","dimension":"Yz-z","dimensionLabels":"Zz-z"};